import { z } from 'zod';

/**
 * Curated allowlist of ISO 639-3 codes accepted by the catalog admin
 * editors. Mirrors the backend's `App\Support\LanguageCodes::ALLOWED`
 * constant — keep both in sync when adding a language.
 */
export const LANGUAGE_CODES = ['deu', 'eng', 'fra', 'ita', 'spa', 'nld'] as const;

export const LanguageCodeSchema = z.enum(LANGUAGE_CODES);

export type LanguageCode = (typeof LANGUAGE_CODES)[number];

export const DEFAULT_LANGUAGE_CODE: LanguageCode = 'deu';

/**
 * Display labels for the language picker. Stored values are the 3-letter
 * codes; users see the language's autonym alongside the code.
 */
export const LANGUAGE_CODE_LABELS: Record<LanguageCode, string> = {
  deu: 'Deutsch (deu)',
  eng: 'English (eng)',
  fra: 'Français (fra)',
  ita: 'Italiano (ita)',
  spa: 'Español (spa)',
  nld: 'Nederlands (nld)',
};
